(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Mobile menu + search */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var a = t.getAttribute('data-action');
    if (a === 'open-menu') $('.mobile-menu').classList.add('is-open');
    if (a === 'close-menu') $('.mobile-menu').classList.remove('is-open');
    if (a === 'toggle-search') {
      var p = $('.search-panel');
      p.hidden = !p.hidden;
      if (!p.hidden) $('input', p).focus();
    }
    if (a === 'open-cart') {
      var d = $('.drawer');
      if (d) { e.preventDefault(); openDrawer(); }
    }
    if (a === 'close-cart') closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Cart drawer */
  function openDrawer() { document.body.classList.add('drawer-open'); }
  function closeDrawer() { document.body.classList.remove('drawer-open'); }

  function refreshCart(open) {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (data) {
        if (!data) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = $('.drawer', doc), cur = $('.drawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          $$('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
        });
        if (open) openDrawer();
      });
  }

  /* Ajax add to cart */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-product-form]')) return;
    if (!$('.drawer')) return;
    e.preventDefault();
    var btn = $('[type=submit]', f);
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message); return; }
        return refreshCart(true);
      })
      .finally(function () { btn.disabled = false; });
  });

  /* Drawer / cart line qty + remove */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    var line = b.getAttribute('data-line'), q = parseInt(b.getAttribute('data-qty'), 10);
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: q })
    }).then(function () {
      if (b.closest('.drawer')) refreshCart(true); else location.reload();
    });
  });

  /* Qty steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var i = $('input', b.parentNode), v = parseInt(i.value, 10) || 1;
    i.value = Math.max(1, v + parseInt(b.getAttribute('data-step'), 10));
  });

  /* Product page: variants + gallery */
  var pj = $('[data-product-json]');
  if (pj) {
    var product = JSON.parse(pj.textContent);
    var form = $('[data-product-form]');
    var idInput = $('[name=id]', form);
    var money = function (c) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100);
    };
    var update = function () {
      var vals = $$('.opt', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      var v = product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); })[0];
      var btn = $('[data-atc]', form), price = $('[data-price]'), cmp = $('[data-compare]');
      if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
      price.textContent = money(v.price);
      if (v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = money(v.compare_at_price); price.parentNode.classList.add('price--sale'); }
      else { cmp.hidden = true; price.parentNode.classList.remove('price--sale'); }
      if (v.featured_media) { var th = $('[data-media-id="' + v.featured_media.id + '"]'); if (th) th.click(); }
      history.replaceState(null, '', '?variant=' + v.id);
    };
    $$('.opt input', form).forEach(function (i) { i.addEventListener('change', update); });
  }
  $$('.gallery__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = $('.gallery__main img');
      main.src = t.getAttribute('data-src');
      main.srcset = '';
      $$('.gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });
})();

/* Article table of contents */
(function () {
  var body = document.querySelector('[data-post-body]');
  var toc = document.querySelector('[data-toc]');
  if (!body || !toc) return;
  var heads = [].slice.call(body.querySelectorAll('h2'));
  if (heads.length < 3) return;
  var list = toc.querySelector('[data-toc-list]');
  heads.forEach(function (h, i) {
    if (!h.id) h.id = 'section-' + (i + 1) + '-' + h.textContent.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    var li = document.createElement('li'), a = document.createElement('a');
    a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); list.appendChild(li);
  });
  toc.hidden = false;
  if (window.matchMedia('(max-width: 989px)').matches) toc.querySelector('details').removeAttribute('open');
  if ('IntersectionObserver' in window) {
    var links = [].slice.call(list.querySelectorAll('a'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
        }
      });
    }, { rootMargin: '-96px 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
})();
